import { useState } from "react";
import { Box, Typography, IconButton, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import MenuIcon      from "@mui/icons-material/Menu";
import LogoutIcon    from "@mui/icons-material/Logout";
import DarkModeIcon  from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import logoEscotta from "../../assets/ttflow-icone@2x.png";
import logoEscottaCyan from "../../assets/ttflow-icone-cyan@3x.png";
import { useTranslation } from "react-i18next";
import AdminDrawer from "../admin/AdminDrawer";
import { useAuth } from "../../context/AuthContext";
import { useThemeMode } from "../../context/ThemeModeContext";

const getInitials = (name) => {
  if (!name) return "U";
  return name.split(/[\s.\-_]+/)
    .filter(Boolean).slice(0, 2)
    .map((p) => p[0].toUpperCase()).join("");
};

const InboundHeader = () => {
  const { t }                = useTranslation();
  const navigate             = useNavigate();
  const { mode, toggleMode } = useThemeMode();
  const { user, logout, hasRole } = useAuth();
  const isAdminOrSuper = hasRole("SUPER") || hasRole("ADMIN");
  const userName             = user?.name || t("app.defaultUser");
  const initials             = getInitials(userName);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <>
      <Box
        sx={{
          height: 56,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 2,
          borderBottom: "1px solid",
          borderColor: "divider",
          backgroundColor: "background.paper",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {isAdminOrSuper && (
            <Tooltip title="Administração">
              <IconButton
                size="small"
                onClick={() => setDrawerOpen(true)}
                sx={{ color: "primary.main" }}
              >
                <MenuIcon />
              </IconButton>
            </Tooltip>
          )}

          <Box
            onClick={() => navigate("/inbound")}
            sx={{ display: "flex", alignItems: "center", gap: 1, cursor: "pointer" }}
          >
            <img
              src={mode === "dark" ? logoEscottaCyan : logoEscotta}
              alt="Escotta"
              style={{ width: 34, height: 34, objectFit: "contain" }}
            />
            <Typography sx={{ fontSize: 17, fontWeight: 700, color: "text.primary" }}>
              {t("app.title")}
            </Typography>
          </Box>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            sx={{
              width: 32, height: 32, borderRadius: "50%",
              backgroundColor: "primary.main", color: "primary.contrastText",
              display: "flex", alignItems: "center", justifyContent: "center",
              fontWeight: 700, fontSize: 12, flexShrink: 0,
            }}
          >
            {initials}
          </Box>

          <Typography sx={{ fontSize: 13, fontWeight: 600, color: "text.primary" }}>
            {userName}
          </Typography>

          <Tooltip title={mode === "dark" ? "Modo claro" : "Modo escuro"}>
            <IconButton size="small" onClick={toggleMode} sx={{ color: "secondary.main", ml: 0.5 }}>
              {mode === "dark" ? <LightModeIcon fontSize="small" /> : <DarkModeIcon fontSize="small" />}
            </IconButton>
          </Tooltip>

          <Tooltip title="Sair">
            <IconButton size="small" onClick={handleLogout} sx={{ color: "text.secondary" }}>
              <LogoutIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>

      <AdminDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
    </>
  );
};

export default InboundHeader;